export const TRANSLATION_NAMESPACE = 'HomePage';

export const APPEAL_TRANSLATIONS = {
  title: 'title',
  subtitle: 'subtitle',
  continueButton: 'continueButton',
  newAppeal: {
    title: 'newAppeal.title',
    tabs: {
      mainInfo: 'newAppeal.tabs.mainInfo',
      sellerAndProducts: 'newAppeal.tabs.sellerAndProducts',
      documents: 'newAppeal.tabs.documents',
    },
    fields: {
      category: {
        label: 'newAppeal.fields.category.label',
        placeholder: 'newAppeal.fields.category.placeholder',
      },
      theme: {
        label: 'newAppeal.fields.theme.label',
        placeholder: 'newAppeal.fields.theme.placeholder',
      },
    },
  },
  header: {
    sellerCourse: 'header.sellerCourse',
    howToStart: 'header.howToStart',
    login: 'header.login',
    register: 'header.register',
    copyright: 'header.copyright',
    terms: 'header.terms',
    restoreAccess: 'header.restoreAccess',
    privacyPolicy: 'header.privacyPolicy',
    ourPartners: 'header.ourPartners',
    sellerWebinars: 'header.sellerWebinars',
    market: 'header.market',
  },
};
